var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.999,
    height: 30.178,
    viewBox: "0 0 102.999 30.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-686.332 -196.084)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(686.004 199.351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.93 1.461) rotate(-4.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.05,22.433l1.714-18.6-3.658-2.8L1.939,0,0,21.046Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.05,22.433l1.714-18.6-3.658-2.8L1.939,0,0,21.046Z",
    fill: "#baaac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.369,21.623,16.006,3.691,12.513.992,1.851,0,0,20.286Z",
    transform: "translate(0.474 0.5)",
    fill: "#8761a1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.658,2.8,0,0,.959,3.353Z",
    transform: "translate(13.106 1.029)",
    fill: "#8761a1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.277) rotate(-6.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.158,
    cy: 3.158,
    r: 3.158,
    transform: "translate(0.38 0.379)",
    fill: "#4c2766"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.519,
    cy: 2.519,
    r: 2.519,
    transform: "translate(0 3.123) rotate(-38.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.113,1.335,2,1.2,2.132.093,1.335,0,1.2,1.111.093.981,0,1.778l1.111.13L.981,3.019l.8.093L1.908,2l1.111.13Z",
    transform: "translate(1.981 1.981)",
    fill: "#4c2766"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 5.698) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 6.959) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 8.22) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 9.482) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 10.743) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 12.005) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111.947H9.1L-.013.149A.15.15,0,0,1-.149-.013.15.15,0,0,1,.013-.149l9.111.8a.15.15,0,0,1-.013.3Z",
    transform: "translate(6.541 13.266) rotate(-4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1.15H0A.15.15,0,0,1-.15,0,.15.15,0,0,1,0-.15H4.1A.15.15,0,0,1,4.25,0,.15.15,0,0,1,4.1.15Z",
    transform: "translate(6.541 14.528)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.115 196.334)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.741,
    height: 29.678,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-.25H37.991V29.928H-.25Zm37.741.5H.25V29.428H37.491Z",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H34.288V26.7H0Z",
    transform: "translate(1.688 1.201)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.133,292.013c-1.6-2.175-3.092-2.765-5.091-.856-3.056,2.916-5.263,9.95-7.13,9.435s-1.867-3.431-3.565-5.49-4.583,2.059-9.846,6.69a22.023,22.023,0,0,1-8.657,4.7v3.2h34.288Z",
    transform: "translate(-102.157 -281.55)",
    fill: "#4c2766"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.375,
    cy: 4.375,
    r: 4.375,
    transform: "matrix(0.161, -0.987, 0.987, 0.161, 4.499, 11.59)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.866 200.977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.46,44.165a.478.478,0,0,1-.477.477H.477A.478.478,0,0,1,0,44.165V25.476A.478.478,0,0,1,.477,25H24.984a.478.478,0,0,1,.477.477Z",
    transform: "translate(0.928 -24.283)",
    fill: "#baaac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,46.223H.511a.665.665,0,0,1-.661-.66V25.51a.665.665,0,0,1,.66-.66H26.8a.665.665,0,0,1,.661.66l0,20.052A.665.665,0,0,1,26.8,46.223ZM.511,25.15a.364.364,0,0,0-.361.361V45.562a.364.364,0,0,0,.362.361H26.8a.364.364,0,0,0,.362-.362l0-20.05a.364.364,0,0,0-.362-.361Z",
    transform: "translate(0 -24.999)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,73.515c0-.524.372-.739.826-.477L91.4,77.7a.5.5,0,0,1,0,.953l-8.077,4.663c-.454.262-.826.048-.826-.477Z",
    transform: "translate(-73.703 -67.641)",
    fill: "#4c2766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.388,73.654l-1.066-.616c-.454-.262-.826-.048-.826.477v9.327c0,.524.372.739.826.477l1.066-.616Z",
    transform: "translate(-73.703 -67.641)",
    fill: "#4c2766"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.407 2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.082,41.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-204.581 -39.513)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.082,79.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-204.581 -73.436)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.082,116.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-204.581 -107.358)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.082,154.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-204.581 -141.281)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.082,191.793a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-204.581 -175.204)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093,41.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -39.513)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093,79.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -73.436)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093,116.8a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -107.358)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093,154.3a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -141.281)",
    fill: "#8761a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093,191.793a.287.287,0,0,1-.286.286h-2a.287.287,0,0,1-.286-.286v-2a.287.287,0,0,1,.286-.286h2a.287.287,0,0,1,.286.286Z",
    transform: "translate(-15.519 -175.204)",
    fill: "#8761a1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/drag-drop.8866f7497becd0ef925902fe63cf5407.svg";
export { ForwardRef as ReactComponent };